import React, { Component } from 'react';
import classNames from 'classnames';
import IconButton from 'material-ui/IconButton';
import { Tab, Tabs } from 'material-ui/Tabs';
import SwipeableViews from 'react-swipeable-views';
import FontIcon from 'material-ui/FontIcon';
import ListPatient from '../modules/patients/list_patient';
import SearchPatient from '../modules/patients/search_patient';
import { Scrollbars } from 'react-custom-scrollbars';
import onClickOutside from 'react-onclickoutside';
const styles = {
  slide: {
    padding: 5,
  },
};
class StyleSwitcher extends Component {
  constructor(props) {
    super(props);
    this.state = {
      slideIndex: 0,
      switcherToggle: false,
      tagSelect: false,
    };
    this.toggleSwitch = this.toggleSwitch.bind(this);
  }
  toggleSwitch() {
    this.setState({ switcherToggle: !this.state.switcherToggle });
  }
  handleChange = (value) => {
    this.setState({
      slideIndex: value,
    });
  };

  tagSelect = (args) => {
    this.setState({
      switcherToggle: true,
    });
  }

  handleClickOutside = () => {
    this.setState({
      switcherToggle: false,
    });
  }

  render() {
    const switcherClass = classNames({
      'readmin-style-switcher': true,
      'toggle': this.state.switcherToggle,
    });
    return (
      <div className={switcherClass} >
        <button className="style-toggle" onClick={this.toggleSwitch}>
          <i className="srach-pt flaticon-symbol"></i>
        </button>
        <IconButton className="clear-btn" onClick={this.toggleSwitch}>
          <i className="material-icons">clear</i>
        </IconButton>
        <p>Client Details</p>
        <Scrollbars>
          <Tabs className="pateintview"
            onChange={this.handleChange}
            value={this.state.slideIndex}
          >
            <Tab icon={
              <FontIcon className="fa fa-list-ul whtic"/>
            } value={0} />
            <Tab icon={
              <i className="material-icons  whtic">loyalty</i>
            } value={1} />
            {/* <Tab icon={
         <FontIcon className="material-icons whtic">favorite</FontIcon>
         } value={2} />*/}
          </Tabs>
          <SwipeableViews
            index={this.state.slideIndex}
            onChangeIndex={this.handleChange}
          >
            <div className="patientlist" style={styles.slide}>
              {/* {this.state.slideIndex === 0 ? */}
                <SearchPatient toggleSwitch={this.toggleSwitch} slideIndex={this.state.slideIndex} />
                {/* : null} */}
            </div>
            <div style={styles.slide}>
              {/* {this.state.slideIndex === 1 ? */}
                <ListPatient toggleSwitch={this.toggleSwitch} tagSelect={this.tagSelect} slideIndex={this.state.slideIndex} />
                {/* : null} */}
            </div>
            {/* <div style={styles.slide}>
            <Like />
         </div>*/}
          </SwipeableViews>
          {/*
      <HeaderLeftStyle />
      <HeaderBannerStyle />
      <SidebarStyle />
      */}
        </Scrollbars>
      </div>
    );
  }
}
export default onClickOutside(StyleSwitcher);



// WEBPACK FOOTER //
// ./src/style-switcher/index.js